var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 143,
    viewBox: "0 0 400 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h400v143H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 0h100.716v100.716H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#FEE",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F8E6E6",
    d: "M.5.5h399v142H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#80959D",
    fillRule: "nonzero",
    opacity: 0.2,
    transform: "translate(221.885 38.208)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.076 33.627h45.855V4.076H4.076v29.551zM0 0h54.007v37.703H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.171 27.513l6.115-17.323 10.981 12.407 6.341-3.05v7.966z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.779,
    cy: 14.266,
    r: 4.076
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.104 7.04l43.533 24.646-16.229 27.548-5.988-3.213.387 5.462 7.762 4.132 21.088-35.81L33.215.116l-15.381 27.16 6.28-1.172z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.179,
    cy: 37.703,
    r: 4.076,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.627 25.475h10.19l-1.85-8.152z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    d: "M86 60h107.399v6.683H86z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    d: "M86 76h83.532v6.683H86z",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25);
export default __webpack_public_path__ + "static/media/group-25.a640c33078be46960aed8adfbfa029eb.svg";
export { ForwardRef as ReactComponent };